import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import KeyHandler from 'react-key-handler'
import FocusTrap from 'focus-trap-react'
import cx from 'classnames'

import Error from '../Error/Error'
import CloseButton from '../CloseButton/CloseButton'

import './Modal.css'
let modalCount = 0
let modalRoot = document.getElementById('modal-root')
if (!modalRoot) {
  modalRoot = document.createElement('div')
  modalRoot.id = 'modal-root'
  document.body.appendChild(modalRoot)
}

const stopEventPropagation = event => {
  event.stopPropagation()
}

class Modal extends React.Component {
  constructor (props) {
    super(props)
    this.modalBodyRef = React.createRef()
    this.el = document.createElement('div')
    this.scrollWidth = window.innerWidth - document.body.clientWidth
  }

  componentDidMount () {
    modalCount++
    if (modalCount === 1) {
      document.body.classList.add('modal-open')
      document.body.style.margin = `0 ${this.scrollWidth}px 0 0`
    }

    modalRoot.appendChild(this.el)
  }

  componentWillUnmount () {
    modalCount--
    if (modalCount === 0) {
      document.body.classList.remove('modal-open')
      document.body.style.margin = ''
    }
    modalRoot.removeChild(this.el)
  }

  render () {
    const { wrapper, header, onClose, footer, children, error, responsive } = this.props
    const contents = wrapper(
      <FocusTrap>
        <div styleName={cx('background', { responsive })} onClick={onClose}>
          <div role='dialog' styleName='modal' onClick={stopEventPropagation}>
            <div styleName='headerWrapper'>
              <div styleName='header'>
                {typeof header === 'string' ? <Modal.Header>{header}</Modal.Header> : header}
              </div>
              {onClose && (
                <div styleName='closeButton'>
                  <CloseButton data-testid='modal-close-button' onClick={onClose} />
                  <KeyHandler keyEventName='keydown' keyValue='Escape' onKeyHandle={onClose} />
                </div>
              )}
            </div>
            {error && <Error error={error} />}
            <div data-testid='modal-body' styleName='body' ref={this.modalBodyRef}>{children}</div>
            {footer && <div styleName='footer'>{footer}</div>}
          </div>
        </div>
      </FocusTrap>
    )
    return ReactDOM.createPortal(contents, this.el)
  }
}

Modal.propTypes = {
  wrapper: PropTypes.func,
  header: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  error: PropTypes.object,
  responsive: PropTypes.bool
}

// TODO: Remove default props from this Component
Modal.defaultProps = {
  wrapper: x => x,
  responsive: true
}

Modal.Header = ({ children }) => <h2 data-testid='modal-default-header' styleName='defaultHeader'>{children}</h2>

Modal.Header.propTypes = {
  children: PropTypes.node
}

Modal.Header.displayName = 'Modal.Header'

export default Modal
